import { useLocale, useT } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

export default function Insights() {
  const locale = useLocale();
  const t = useT();
  const state = useApiData(() => contentApi.insights(locale), [locale]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head reveal is-visible">
          <span className="eyebrow">{t('nav.insights')}</span>
          <h1>Insights</h1>
        </div>
        <AsyncSection
          state={state}
          emptyMessage="No research briefs or articles are published yet."
          render={(items) => (
            <div className="card-grid">
              {items.map((i: any) => (
                <div className="card reveal is-visible" key={i.slug}>
                  <h3>{i.title}</h3>
                  <p className="body-sm">{i.summary}</p>
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </section>
  );
}
